import { useQuery } from "@tanstack/react-query";
import { getWidgetFilterOptions } from "@/services/v2/widgetService";

// Reference data (property/finance/timeline/purchase type lists) for the
// search widget's filter chips. Effectively static, so it's fetched once
// and never refetched for the life of the embed.
const useWidgetFilterOptions = () =>
  useQuery({
    queryKey: ["widgetFilterOptions"],
    queryFn: getWidgetFilterOptions,
    staleTime: Infinity,
    retry: false,
  });

export default useWidgetFilterOptions;
